import { buildRegisterDocNumber } from "./Dashboard/docListAPI";

/** Full document # as shown in the doc register (e.g. 1001-PDS-V-101). */
export function resolveRegisterDocNumber(doc) {
  if (!doc || typeof doc !== "object") return "";
  const explicit = doc.documentNumber ?? doc.docNumber;
  if (explicit != null && String(explicit).trim() !== "") {
    return String(explicit).trim();
  }
  return buildRegisterDocNumber(doc);
}

export function resolveRegisterDescription(doc) {
  return String(doc?.description ?? doc?.title ?? "").trim();
}

export function findRegisterDocById(documentList, docId) {
  if (!docId || !Array.isArray(documentList)) return null;
  return documentList.find((d) => String(d?.id) === String(docId)) ?? null;
}

export function findRegisterDocByNumber(documentList, docNumber) {
  const key = String(docNumber ?? "").trim();
  if (!key || !Array.isArray(documentList)) return null;
  return (
    documentList.find((d) => resolveRegisterDocNumber(d) === key) ?? null
  );
}
